// TODO

export default class ComponentsMap {
  constructor() {

  }

  static fromObject(obj) {
    return new ComponentsMap(obj);
  }

  toObject(): Object {

  }
}
